import script from "./QuickpaySettingsBlockPreferences.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsBlockPreferences.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsBlockPreferences.vue?vue&type=style&index=0&id=1098d078&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1098d078"]])

export default __exports__